// Gemeinsame Klassen für die Passwort-vergessen-Schritte (gleich wie Login/Register)
export const inputClass =
  "h-[52px] w-full rounded-[10px] border bg-ao-bg px-4 text-[15px] text-ao-fg placeholder:text-ao-muted transition-colors focus:border-ao-accent focus:outline-none";
export const labelClass = "text-[13px] font-semibold text-ao-muted";
export const errorClass = "text-sm text-red-600 dark:text-red-400";
export const buttonClass =
  "mt-2 flex h-[54px] items-center justify-center rounded-xl bg-ao-accent text-base font-bold text-ao-on-accent transition-colors hover:bg-ao-accent-hover disabled:cursor-not-allowed disabled:opacity-60";

// Fehler aus unwrap() kann Text oder Error sein
export const errorText = (error: any, fallback: string) =>
  typeof error === "string" ? error : error?.message || fallback;